import useColorThemeStore from './useColorThemeStore';

export default function initializeColorTheme() {
  const colorThemeStore = useColorThemeStore();

  colorThemeStore.initializeColorTheme();
}
